import styles from './EidItem.module.scss';
import useSWR from 'swr';
import PromoBonus from 'Components/blocks/Bonuses/PromoBonus/PromoBonus';
import { POSITIONS, EOverlayContentWidth } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';
import { t } from 'i18next';
import { basicChannel } from 'src/channels/basic.channel';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';
import { EBasicOverlays } from 'Components/shared/Overlay/elements/BasicOverlayManager/types';

export interface IEidItem {
  eid: string;
  title?: string;
  description?: string;
  is_table_shown?: boolean;
  is_button_shown?: boolean;
  btn_text?: string;
  btn_url?: string;
  authorized_btn_url?: string;
  authorized_btn_text?: string;
  override_bonus_image?: string;
  override_bonus_terms?: string;
}

function BonusSWR(eid) {
  const fetcher = url => fetch(url).then(r => r.json());

  const { data } = useSWR(`/api/bonus/promo?0=${eid}`, fetcher, {
    revalidateOnFocus: false,
  });

  return data || {};
}

const EidItem = (props: IEidItem) => {
  const currentBonus = props?.eid ? BonusSWR(props?.eid)?.bonus : null;

  const { integrationKeys } = useSelector((state: IApplicationState) => state.globalReducer);

  const getIntegration = item => {
    let integrationKey = integrationKeys.keys?.[item?.urlKey];

    return integrationKey ?? false;
  };

  const integrationKey = getIntegration(currentBonus?.data?.free_rounds?.game);

  //quick

  const onPrimary = () => {
    localStorage.setItem('promoMetadata', JSON.stringify(currentBonus));
    basicChannel.send({
      action: 'display',
      data: {
        content: {
          type: EBasicOverlays.BonusInfoPromo,
          overlayTitle: t('dashboard.bonus.deposit.title'),
          eid: currentBonus?.eid,
          noRoundedCorners: true,
          fullMobileHeight: true,
          isSelected: false,
          isWelcomeBonus: true,
          title: props?.title,
          description: props?.description,
        },
        position: POSITIONS.CENTER,
        contentWidth: EOverlayContentWidth.LARGE,
      },
    });
  };

  return (
    <div className={classNames(styles.eid_item, props?.is_table_shown ? styles.eid_item__expanded : '')}>
      <PromoBonus
        title={props?.title}
        description={props?.description}
        is_table_shown={props?.is_table_shown}
        is_button_shown={props?.is_button_shown}
        bonus={currentBonus}
        isSelected={false}
        onPrimaryAction={onPrimary}
        btn_text={props?.btn_text}
        btn_url={props?.btn_url}
        authorized_btn_url={props?.authorized_btn_url}
        authorized_btn_text={props?.authorized_btn_text}
        override_bonus_image={props?.override_bonus_image}
        override_bonus_terms={props?.override_bonus_terms}
        integration_key={integrationKey}
      ></PromoBonus>
    </div>
  );
};

export default EidItem;
